export default "__VITE_ASSET__BgyNfumz__"